import { render, staticRenderFns } from "./RelatorioImovel.vue?vue&type=template&id=60d1f1e8&"
import script from "./RelatorioImovel.vue?vue&type=script&lang=js&"
export * from "./RelatorioImovel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports